import { Divider, FormControl, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOptions, setChartTime, setChartType, setFluid, setFluidRatio, setFluids, setNormalization, setShowOutliers, setShowPressure } from '../reducers/optionsSlice';


const useStyles = makeStyles(theme => ({
  chartOptionsHorizontal: {
    position: 'relative',  
    overflow: 'hidden',
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: 20,
    marginBottom: 5
  },
}));

export const ViewCDGRJobChartOptions = ({ list, currentTab, darkMode }) => {
  const classes = useStyles();

  const options = useSelector(selectOptions);

  const dispatch = useDispatch();

  const handleShowOutliersChange = (event, newOutliers) => {
    newOutliers && dispatch(setShowOutliers(newOutliers));
  };
  const handlePressureChange = (event, newPressure) => {
    newPressure && dispatch(setShowPressure(newPressure));
  };
  const handleChartTypeChange = (event, newType) => {
    newType && dispatch(setChartType(newType));
  };
  const handleChartTimeChange = (event, newTime) => {
    newTime && dispatch(setChartTime(newTime));
  };
  const handleChartNormalizationChange = (event, newNorm) => {
    newNorm && dispatch(setNormalization(newNorm));
  };
  const handleFluidRatioChange = (event, newRatio) => {
    newRatio && dispatch(setFluidRatio(newRatio));
  };
  const handleChartFluidsChange = (event, newFluids) => {
    try {
      newFluids && dispatch(setFluids({fluids: newFluids}));
    } catch (error) {
      console.log('Could not change chart fluids!');
    };
  };

  useEffect(() => {
    if (options.chartTime === 'Absolute' && options.chartType === 'Rate-Cum.') {
      dispatch(setChartTime('Relative'));
    } else if (currentTab === 2 && options?.chartTime === 'Absolute') {
      dispatch(setChartTime('Relative'));
    };

    if ((currentTab === 2 || currentTab === 3) && options.showPressure === 'Show') {
      dispatch(setShowPressure('Hide'));
    };

    return () => {};
  }, [options.chartTime, options.chartType, currentTab, dispatch, options.showPressure]);

  useEffect(() => {

    if (options.fluidRatio === 'Off') {
      dispatch(setFluidRatio('CGR'));
    };

    if (options.fluid === 'oil') {
      dispatch(setFluid({fluid: 'gas'}));
    };

    dispatch(setFluids({fluids: ['gas', 'condensate']}));
    
  }, []); //eslint-disable-line

  return (
    <div className={classes.chartOptionsHorizontal}>   
      <FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART FLUIDS
        </Typography>
        <ToggleButtonGroup
          value={options.fluids}
          onChange={handleChartFluidsChange}
          size="small"
          style={{height: 20, marginTop: 0}}
        >
          <ToggleButton value="gas" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Gas
            </Typography>
          </ToggleButton>
          <ToggleButton value="condensate" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Condensate
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      {<FormControl style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          FLUID RATIO
        </Typography>
        <ToggleButtonGroup
          value={options.fluidRatio}
          onChange={handleFluidRatioChange}
          size="small"
          style={{height: 20, marginTop: 0}}
          exclusive
        >
          <ToggleButton value="Off" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Off
            </Typography>
          </ToggleButton>
          <ToggleButton value="CGR" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              CGR
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>}

      {(currentTab === 0 || currentTab === 1 || currentTab === 4 || currentTab === 5) && <FormControl component="fieldset" style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          PRESSURE
        </Typography>
        <ToggleButtonGroup
          value={options.showPressure}
          exclusive
          onChange={handlePressureChange}
          size="small"
          style={{height: 30, marginTop: 0}}
        >
          <ToggleButton value="Show" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value="Hide" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>}

      {(currentTab === 0 || currentTab === 1 || currentTab === 4) && <FormControl style={{marginRight: 10}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          OUTLIERS
        </Typography>
        <ToggleButtonGroup
          value={options?.showOutliers}
          onChange={handleShowOutliersChange}
          size="small"
          style={{height: 20, marginTop: 0}}
          exclusive
        >
          <ToggleButton value="Show" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Show
            </Typography>
          </ToggleButton>
          <ToggleButton value="Hide" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Hide
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>}

      <FormControl style={{marginRight: 10}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART TYPE
        </Typography>
        <ToggleButtonGroup
          value={options?.chartType}
          onChange={handleChartTypeChange}
          size="small"
          style={{height: 20, marginTop: 0}}
          exclusive
        >
          <ToggleButton value="Rate-Time" fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Rate-Time
            </Typography>
          </ToggleButton>
          <ToggleButton value="Rate-Cum." fontSize="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Rate-Cum.
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>

      {(currentTab === 0 || currentTab === 1 || currentTab === 4 || currentTab === 5) && <FormControl component="fieldset" style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          CHART TIME
        </Typography>
        <ToggleButtonGroup
          value={options.chartTime}
          exclusive
          onChange={handleChartTimeChange}
          size="small"
          style={{height: 20, marginTop: 0}}
        >
          <ToggleButton value="Relative" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Relative
            </Typography>
          </ToggleButton>
          <ToggleButton value="Absolute" size="small" color={(darkMode ? "" : "primary")} disabled={options.chartType === 'Rate-Cum.'} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Absolute
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>}

      {currentTab !== 3 && currentTab !== 2 && <FormControl component="fieldset" style={{marginRight: 10, marginBottom: 5}}>
        <Typography variant="subtitle2" color="textSecondary" style={{fontWeight: 'bold', fontSize: 10}}>
          NORMALIZATION
        </Typography>
        <ToggleButtonGroup
          value={options.normalization}
          exclusive
          onChange={handleChartNormalizationChange}
          size="small"
          style={{height: 20, marginTop: 0}}
        >
          <ToggleButton value="off" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Off
            </Typography>
          </ToggleButton>
          <ToggleButton value="length" size="small" color={(darkMode ? "" : "primary")} style={{height: 20}}>
            <Typography style={{fontSize: 10}}>
              Length
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>}

      <Divider style={{marginTop: 10}} />
    </div>
  );

};
